var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-drag-select"},[(_vm.mouseDown)?_c('div',{staticClass:"vue-drag-select-box",style:(_vm.selectionBoxStyling)}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }